import React from 'react';
import { Button } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { BranchItem } from './BranchItem';

export const BranchItems = observer(({ items, hasNewBranch, updateBranchItem, addNewBranch, saveBranchItem }) => {
  const sortedItems = items.slice().sort((a, b) => a.name.localeCompare(b.name));
  return (
    <div>
      <h3>Branches</h3>
      {
        sortedItems.map((item, index) => <BranchItem key={index} item={item} updateBranchItem={updateBranchItem} saveBranchItem={saveBranchItem}/>)
      }
      <Button disabled={hasNewBranch} onClick={addNewBranch}>Add Branch</Button>
    </div>
  );
});